export default __webpack_public_path__ + "static/media/ex_img_01.8e123ec0.png";